import React from 'react';
import { Link } from 'react-router-dom';

// Body copy lives in the localisation data files as plain strings, which means a
// sentence cannot carry JSX. Authoring links as markdown — [text](/claude) —
// keeps one string per sentence: renderTextWithLinks turns the markup into real
// links for the page, and stripMarkdownLinks hands the bare words to JSON-LD,
// where markup would show up verbatim in the rich result.
const LINK_PATTERN = /\[([^\]]+)\]\(([^)\s]+)\)/g;

export const stripMarkdownLinks = (text = '') =>
  text.replace(LINK_PATTERN, '$1');

export const renderTextWithLinks = (text = '', className = 'inline-link') => {
  const parts = [];
  let lastIndex = 0;
  let match;

  LINK_PATTERN.lastIndex = 0;
  while ((match = LINK_PATTERN.exec(text)) !== null) {
    const [full, label, href] = match;

    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    parts.push(
      href.startsWith('/')
        ? <Link key={`${href}-${match.index}`} className={className} to={href}>{label}</Link>
        : <a key={`${href}-${match.index}`} className={className} href={href} target="_blank" rel="noopener noreferrer">{label}</a>
    );

    lastIndex = match.index + full.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};
